// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1rYSM","checked":"Checkbox_checked__2AKPD","text":"Checkbox_text__3Bruc","unchecked":"Checkbox_unchecked__2PKfz","wrapper":"Checkbox_wrapper__8JHIn"};